export const FEATURE_UNDER_DEVELOPMENT_LABEL = "Feature under development";
